import { Homepage } from './HomepageObjClass'
import { provideDefaultPageLayoutComponent } from '../defaultPageLayoutComponent'

provideDefaultPageLayoutComponent(Homepage)
